import { Injectable } from '@angular/core';
import { Observable, repeat } from 'rxjs';
import { AbstractRestService, GenericLambdaReturn } from '@gea-mes/cognito';

@Injectable({
  providedIn: 'root'
})
export class TasklistService extends AbstractRestService  
{
  postInit(): void { }

  
  taskList(site: string, environment: string, object: string, shiftdate: string, shift: string):Observable<GenericLambdaReturn<TaskListType>> 
  {
    return this.get({
      ApiResource: "/tasklist",
      data: {
        Site: site,
        Environment: environment,
        Object: object,
        ShiftDate: shiftdate,
        Shift: shift
      }
    })
  }

  eamCheck(id:number):Observable<GenericLambdaReturn<EAMPriorWorkRequest>> 
  {
    let params:any={};

    params.id = id;

    return this.get({
      ApiResource: "/eam/check",
      data: params,
      repeatCall: false
    })
  }

  eamAssociate(site:string, id:number, priorID: number, input_data:string=""):Observable<GenericLambdaReturn<any>> {
    let params:any={};

    params.Site = site;
    params.id = id;
    params.PriorID = priorID;
    params.input_data = input_data;

    return this.post({
      ApiResource: "/eam/associate",
      data: params,
      repeatCall: false
    })
  }

  completeTask(id: number, site: string, comment?: string, correctiveAction?: string, tagno?: string, status?: number, inputData?: string):Observable<GenericLambdaReturn<TaskListType>> 
  {
    let params:any={};

    params.id = id;
    params.Site = site;

    comment != null ? params.comment=comment:null
    status != null ? params.status = status:null
    correctiveAction != null ? params.correctiveaction = correctiveAction:null
    tagno != null ? params.tagno = tagno:null
    inputData != null ? params.input_data = inputData:null

    return this.post({
      ApiResource: "/tasklist",
      data: { 
        data: params
      }
    })
  }

  postDidNotCompleteList(ids: number[], comment: string, plant:string) {
    let params:any={};

    params.ids = ids;
    comment ? params.comment=comment:null;
    params.plant = plant;

    return this.post({
      ApiResource: "/allnotcomplete",
      data: { 
        data: params
      }
    });      
  }

  admintaskList(site: string, object: string):Observable<GenericLambdaReturn<TaskListType>> 
  {
    return this.get({
      ApiResource: "/configTasks",
      data: {
        Site: site,
        Object: object
      }
    });
  }

  validatorTaskList(taskType?: string):Observable<GenericLambdaReturn<TaskListType>> {
    let params:any={};

    params.Type = "USER";
    taskType ? params.TaskType=taskType:null;

    return this.get({
      ApiResource: "/configTasks",
      data: params,
      repeatCall: false
    })
  }

  getExcelS3DownloadLink(site: string, environment: string, objectID: string):Observable<GenericLambdaReturn<any>>  {
    let params:any={};

    params.Site = site;
    params.Environment = environment;
    params.ObjectID = objectID;

    return this.get({
      ApiResource: "/configs3download",
      data: params,
      repeatCall: false
    });
  }
  
  getExcelFile(signedURL: string):Observable<Blob> {
    return this.getBinary({
      ApiCompleteURL: signedURL,
      disableAuthHeader: true,
      disableTimeParam: true,
      repeatCall: false
    });
  }
}

export type EAMPriorWorkRequest = {
  PriorWorkRequest:boolean;
  id?: number;
  task_type?: string;
  time_period?: string;
  comment?: string;
  corrective_action?: string;
  completed?: number;
  workrequest_number?: string;
  workrequest_data: WorkRequestData;
}

export type WorkRequestData = {
  EAM_TYPE: string;
  ASSET_NUMBER: string;
  DESCRIPTION: string;
  WR_WO_NUMBER: string;
  WORK_TYPE: string;
  PRIORTY: string;
  STATUS: string;
  CREATION_DATE: string;
}

export type TaskListType = {
  status: StatusType;
  tasks: TaskType[];

}

export type StatusType = {
  MONTH: StatusDetailType;
  SHIFT: StatusDetailType;
  WEEK: StatusDetailType;
  BIWEEKLY: StatusDetailType;

}

export type StatusDetailType = {
  last_complete_date: string;
  completed_tasks: number;
  total_tasks: number;
}

export type TaskType = {
  id: number;
  task_type: string;
  seq: number;
  type: string;
  task: string;
  time: string;
  otherinfo: string;
  comment: string;
  corective_action: string;
  tag_no: string;
  completed: number;
  completed_timestamp: Date;
  completed_userId: string;
  configid: number;
  files: number;
  required_input?: string;
  input_data?: string;
}

export type TaskUpdate = {
  id: number;
}
